<template>
    <div class="tab">
        <el-tabs @tab-click="handleClick" value="1">
            <el-tab-pane label="购买项目信息" name="1">
                <div>
                    <el-table v-loading="loading" :data="tableData1" :height="tabHeight">
                        <el-table-column type="selection" width="55"></el-table-column>
                        <el-table-column sortable prop="id" label="ID"></el-table-column>
                        <el-table-column sortable prop="projectName" label="项目名称"></el-table-column>
                        <el-table-column sortable prop="projectReplenish" label="项目补充"></el-table-column>
                        <el-table-column sortable prop="createTime" label="订购日期"></el-table-column>
                        <el-table-column sortable prop="purchaseNumber" label="订购次数"></el-table-column>
                        <el-table-column sortable prop="projectAmt" label="价格"></el-table-column>
                        <!-- <el-table-column sortable prop="residueNumber" label="剩余次数"></el-table-column> -->
                        <el-table-column sortable prop="musProjectReplenish" label="划扣补充"></el-table-column>
                        <el-table-column sortable prop="remark" label="备注"></el-table-column>
                    </el-table>
                    <el-pagination @size-change="handleSizeChange1" @current-change="pageChanged1" :current-page="filters1.pagination.page" :page-size="filters1.pagination.limit" :page-sizes="[10, 20, 30, 50]" layout="total, sizes,prev, pager, next, jumper" :total="filters1.pagination.total">
                    </el-pagination>
                </div>
            </el-tab-pane>
            <el-tab-pane label="划扣项目信息" name="2">
                <div>
                    <el-table v-loading="loading" :data="tableData2" :height="tabHeight">
                        <el-table-column type="selection" width="55"></el-table-column>
                        <el-table-column sortable prop="id" label="ID"></el-table-column>
                        <el-table-column sortable prop="musProjectName" label="当日扣除项目"></el-table-column>
                        <el-table-column sortable prop="musAmt" label="当日扣除金额"></el-table-column>
                        <el-table-column sortable prop="instrumentName" label="仪器"></el-table-column>
                        <el-table-column sortable prop="musContent" label="划扣次数"></el-table-column>
                        <el-table-column sortable prop="musReplenish" label="划扣补充"></el-table-column>
                        <el-table-column sortable prop="musCode" label="划扣卡号"></el-table-column>
                        <el-table-column sortable prop="remark" label="备注"></el-table-column>
                        <el-table-column sortable prop=" " label="耗材名称">
                            <template slot-scope="scope">
                                <div v-for="(item,index) in scope.row.materialList" :key="index">
                                    <span>{{item.materialName}}</span>
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column sortable prop=" " label="耗材规格">
                            <template slot-scope="scope">
                                <div v-for="(item,index) in scope.row.materialList" :key="index">
                                    <span>{{item.materialSpec}}</span>
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column sortable prop=" " label="厂家">
                            <template slot-scope="scope">
                                <div v-for="(item,index) in scope.row.materialList" :key="index">
                                    <span>{{item.manufacturers}}</span>
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column sortable prop="" label="数量">
                            <template slot-scope="scope">
                                <div v-for="(item,index) in scope.row.materialList" :key="index">
                                    <span>{{item.number}}</span>
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column sortable prop="" label="实际使用">
                            <template slot-scope="scope">
                                <div v-for="(item,index) in scope.row.materialList" :key="index">
                                    <span>{{item.actualUse }}</span>
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column sortable prop="doctorName" label="医生"></el-table-column>
                        <el-table-column sortable prop="aideName" label="医助"></el-table-column>
                        <el-table-column align="center" label="操作" width="120">
                            <template slot-scope="scope">
                                <el-button :disabled="scope.row.status=='0'?false:true" size="mini" type="primary" @click="cancle(scope.$index, scope.row)">取消划扣</el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                    <el-pagination @size-change="handleSizeChange2" @current-change="pageChanged2" :current-page="filters2.pagination.page" :page-size="filters2.pagination.limit" :page-sizes="[10, 20, 30, 50]" layout="total, sizes,prev, pager, next, jumper" :total="filters2.pagination.total">
                    </el-pagination>
                </div>
            </el-tab-pane>
            <!-- <el-tab-pane label="咨询记录" name="3">
                <div >
                    <el-table :data="tableData3" style="width: 100%" :header-cell-style="{color:'#464C5B'}">
                        <el-table-column type="selection" width="55">
                        </el-table-column>
                        <el-table-column prop="consignee" label="姓名" width="160"></el-table-column>
                        <el-table-column prop="phone" label="手机号" width="120"></el-table-column>
                        <el-table-column prop="shipAddress" label="地区" width="250"></el-table-column>
                        <el-table-column prop="remark" label="详细地址" width="500"></el-table-column>
                        <el-table-column prop="createTime" label="添加时间" width="200"></el-table-column>
                        <el-table-column prop="" label="是否默认" width="270">
                            <template slot-scope="scope">
                                <el-switch disabled v-model="scope.row.isDefault" :inactive-value="0" :active-value="1" active-color="#13ce66" inactive-color="#C9C9C9" @change=change(scope.$index,scope.row)>
                                </el-switch>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
            </el-tab-pane> -->
            <!-- <el-tab-pane label="回访记录" name="4">
                <div >
                    <el-table :data="tableData4">
                        <el-table-column type="selection" width="55"></el-table-column>
                        <el-table-column prop="id" label="编号"></el-table-column>
                        <el-table-column prop="scoTitle" label="类型"></el-table-column>
                        <el-table-column prop="scoCount" label="变化值"></el-table-column>
                        <el-table-column prop="validTime" label="有效期"></el-table-column>
                        <el-table-column prop="creatTime" label="添加时间" width="100"></el-table-column>
                    </el-table>
                    <el-pagination @size-change="handleSizeChange1" @current-change="pageChanged1" :current-page="filters1.pagination.page" :page-size="filters1.pagination.limit" :page-sizes="[10, 20, 30, 50]" layout="total, sizes,prev, pager, next, jumper" :total="filters1.pagination.total">
                    </el-pagination>
                </div>
            </el-tab-pane> -->
            <!-- <el-tab-pane label="预约记录" name="5">优惠券记录</el-tab-pane> -->
            <!-- <el-tab-pane label="病历" name="6">
                <div>
                    <el-table :data="tableData6" :height="tabHeight">
                        <el-table-column type="selection" width="55"></el-table-column>
                        <el-table-column sortable prop="caseCode" label="病历号" width="100"></el-table-column>
                        <el-table-column sortable prop="treatmentTime" label="治疗日期" width="100"></el-table-column>
                        <el-table-column sortable prop="diagnosisName" label="诊断" width=""></el-table-column>
                        <el-table-column sortable prop="earName" label="院区" width="80"></el-table-column>
                        <el-table-column sortable prop="departmentName" label="科室" width="75"></el-table-column>
                        <el-table-column sortable prop="createBy" label="创建人" width="100"></el-table-column>
                        <el-table-column sortable prop="createTime" label="创建时间" width="100"></el-table-column>
                    </el-table>
                    <el-pagination @size-change="handleSizeChange6" @current-change="pageChanged6" :current-page="filters6.pagination.page" :page-size="filters6.pagination.limit" :page-sizes="[10, 20, 30, 50]" layout="total, sizes,prev, pager, next, jumper" :total="filters6.pagination.total">
                    </el-pagination>
                </div>
            </el-tab-pane> -->
            <el-tab-pane label="已订购" name="7">
                <div>
                    <el-table v-loading="loading" :data="tableData7" :height="tabHeight" :row-class-name="tableRowClassName">
                        <el-table-column type="selection" width="55"></el-table-column>
                        <el-table-column prop="earId" label="消费机构"></el-table-column>
                        <el-table-column prop="projectName" width="160" label="项目名称"></el-table-column>
                        <el-table-column prop="orderTime" label="成交日期" width="100"></el-table-column>
                        <el-table-column prop="orderNum" label="订购次数"></el-table-column>
                        <!-- <el-table-column prop="orderNum" label="截止日期"></el-table-column> -->
                        <el-table-column prop="price" label="价格"></el-table-column>
                        <el-table-column prop="discount" label="折扣"></el-table-column>
                        <el-table-column prop="payableAmount" label="应付金额"></el-table-column>
                        <el-table-column prop="amountPaid" label="已付金额"></el-table-column>
                        <el-table-column prop="couponPrice" label="其中消费券"></el-table-column>
                        <!-- <el-table-column prop="residueNum" label="剩余次数"></el-table-column> -->
                        <el-table-column prop="status" label="状态">
                            <template slot-scope="scope">
                                <span v-if="scope.row.status=='USE'">待划扣</span>
                                <span v-if="scope.row.status=='FSH'">已完成</span>
                                <span v-if="scope.row.status=='RTD'">退费</span>
                                <span v-if="scope.row.status=='CAN'">取消</span>
                                <span v-if="scope.row.status=='OVR'">过期</span>
                                <span v-if="scope.row.status=='WTP'">未收费</span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="empName" label="顾问"></el-table-column>
                        <el-table-column prop="remark" label="备注"></el-table-column>
                    </el-table>
                    <el-pagination @size-change="handleSizeChange7" @current-change="pageChanged7" :current-page="filters7.pagination.page" :page-size="filters7.pagination.limit" :page-sizes="[10, 20, 30, 50]" layout="total, sizes,prev, pager, next, jumper" :total="filters7.pagination.total">
                    </el-pagination>
                </div>
            </el-tab-pane>
            <el-tab-pane label="已消费" name="8">
                <div>
                    <el-table v-loading="loading" :data="tableData8" :height="tabHeight">
                        <el-table-column type="selection" width="55"></el-table-column>
                        <el-table-column prop="index" label="编号"></el-table-column>
                        <el-table-column prop="earId" label="消费机构"></el-table-column>
                        <el-table-column prop="projectName" width="160" label="项目名称"></el-table-column>
                        <el-table-column prop="spec" label="规格"></el-table-column>
                        <el-table-column prop="departmentType" label="科目类型"></el-table-column>
                        <el-table-column prop="consumptionType" label="消费类型"></el-table-column>
                        <el-table-column prop="orderTime" label="成交日期" width="100"></el-table-column>
                        <el-table-column prop="number" label="次数/数量"></el-table-column>
                        <el-table-column prop="price" label="单价"></el-table-column>
                        <el-table-column prop="discount" label="折扣"></el-table-column>
                        <el-table-column prop="payableAmount" label="应付额"></el-table-column>
                        <el-table-column prop="amountPaid" label="已付金额"></el-table-column>
                        <el-table-column prop="arrearsPrice" label="欠款金额"></el-table-column>
                        <!-- <el-table-column prop="residueNum" label="剩余次数"></el-table-column> -->
                        <el-table-column prop="operationTime" label="手术时间" width="100"></el-table-column>
                        <el-table-column prop="empName" label="顾问"></el-table-column>
                        <el-table-column prop="doctor" label="医生"></el-table-column>
                        <el-table-column prop="remark" label="备注"></el-table-column>
                    </el-table>
                    <el-pagination @size-change="handleSizeChange8" @current-change="pageChanged8" :current-page="filters8.pagination.page" :page-size="filters8.pagination.limit" :page-sizes="[10, 20, 30, 50]" layout="total, sizes,prev, pager, next, jumper" :total="filters8.pagination.total">
                    </el-pagination>
                </div>
            </el-tab-pane>
        </el-tabs>
    </div>
</template>
<script>
export default {
    props: ['userCode'],
    data() {
        return {
            value: false,
            filters1: {
                pagination: {
                    page: 1,
                    limit: 10,
                    total: 0
                }
            },
            filters2: {
                pagination: {
                    page: 1,
                    limit: 10,
                    total: 0
                }
            },
            filters3: {
                pagination: {
                    page: 1,
                    limit: 10,
                    total: 0
                }
            },
            filters6: {
                pagination: {
                    page: 1,
                    limit: 10,
                    total: 0
                }
            },
            filters7: {
                pagination: {
                    page: 1,
                    limit: 10,
                    total: 0
                }
            },
            filters8: {
                pagination: {
                    page: 1,
                    limit: 10,
                    total: 0
                }
            },
            tableData1: [],
            tableData2: [],
            tableData3: [],
            tableData4: [],
            tableData5: [],
            tableData6: [],
            tableData7: [],
            tableData8: [],
            activeName: [],
            tabValue: '1',
            tabHeight: '',
            loading: true,
        }
    },
    created() {
        this.tabHeight = document.documentElement.clientHeight - 460
        this.init()
    },
    watch: {
        '$route'(to, from) {
            // this.init()
        }
    },
    methods: {
        init() {
            // 购买项目信息
            if (this.tabValue == '1') {
                var page = this.filters1.pagination.page
                var limit = this.filters1.pagination.limit
                if (this.userCode) {
                    api.request("customer/findCustomerInfoByIdPurchase", { page: page, size: limit, ctmCode: this.userCode, }, (res) => {
                        this.loading = false
                        this.tableData1 = res.data.list
                        this.filters1.pagination.total = parseInt(res.data.count)
                    })
                }
            }
            // 划扣项目信息
            if (this.tabValue == '2') {
                var page = this.filters2.pagination.page
                var limit = this.filters2.pagination.limit
                api.request("customer/findCustomerInfoByIdMus", { page: page, size: limit, ctmCode: this.userCode, }, (res) => {
                    this.loading = false
                    this.tableData2 = res.data.list
                    this.filters2.pagination.total = parseInt(res.data.count)
                })
            }
            // 病历
            if (this.tabValue == '6') {
                var page = this.filters6.pagination.page
                var limit = this.filters6.pagination.limit
                api.request("customer/findCustomerInfoByIdSknCase", { page: page, size: limit, ctmCode: this.userCode, }, (res) => {
                    this.loading = false
                    this.tableData6 = res.data.list
                    this.filters6.pagination.total = parseInt(res.data.count)
                })
            }
            //已订购
            if (this.tabValue == '7') {
                var page = this.filters7.pagination.page
                var limit = this.filters7.pagination.limit
                api.request("customer/findCustomerInfoByIdCtmPurchase", { page: page, size: limit, ctmCode: this.userCode, }, (res) => {
                    this.loading = false
                    this.tableData7 = res.data.list
                    this.filters7.pagination.total = parseInt(res.data.count)
                })
            }
            //已消费
            if (this.tabValue == '8') {
                var page = this.filters8.pagination.page
                var limit = this.filters8.pagination.limit
                api.request("customer/findCustomerInfoByIdCtmConsumption", { page: page, size: limit, ctmCode: this.userCode, }, (res) => {
                    this.loading = false
                    this.tableData8 = res.data.list
                    this.filters8.pagination.total = parseInt(res.data.count)
                })
            }

        },
        handleClick(tab, event) {
            this.tabValue = tab.name
            this.loading = true
            this.init()
        },
        pageChanged1(page) {
            this.filters1.pagination.page = page
            this.loading = true
            this.init()
        },
        handleSizeChange1(sizes) {
            this.filters1.pagination.limit = sizes
            this.loading = true
            this.init()
        },
        pageChanged2(page) {
            this.filters2.pagination.page = page
            this.loading = true
            this.init()
        },
        handleSizeChange2(sizes) {
            this.filters2.pagination.limit = sizes
            this.loading = true
            this.init()
        },
        pageChanged6(page) {
            this.filters6.pagination.page = page
            this.loading = true
            this.init()
        },
        handleSizeChange6(sizes) {
            this.filters6.pagination.limit = sizes
            this.loading = true
            this.init()
        },
        pageChanged7(page) {
            this.filters7.pagination.page = page
            this.loading = true
            this.init()
        },
        handleSizeChange7(sizes) {
            this.filters7.pagination.limit = sizes
            this.loading = true
            this.init()
        },
        pageChanged8(page) {
            this.filters8.pagination.page = page
            this.loading = true
            this.init()
        },
        handleSizeChange8(sizes) {
            this.filters8.pagination.limit = sizes
            this.loading = true
            this.init()
        },
        // 表格不同行设置不同的样式
        tableRowClassName({
            row,
            rowIndex
        }) {
            // 待划扣黑色，已完成绿色，退费红色，取消黄色，过期和未收费红色背景
            if (row.status == 'FSH') {
                return 'warningGreen';
            } else if (row.status == 'USE') {
                return 'warningBlack';
            } else if (row.status == 'RTD') {
                return 'warningRed';
            } else if (row.status == 'CAN') {
                return 'warningYellow';
            } else if (row.status == 'OVR' || row.status == 'WTP') {
                return 'redBank';
            }
            return '';

        },
        cancle(index, row) {
            api.request("skn/cancellationSknMusInformation", { id: row.id, }, (res) => {
                console.log(res);
                if (res.result == true) {
                    _g.toast('success', '取消划扣成功!!!')
                    this.init()
                } else {
                    _g.toast('error', '取消划扣失败!!!')
                }
            }, (err) => { })
        }
    }
}
</script>
<style scoped>
.hea {
  display: flex;
  align-items: center;
}
.hea_item {
  width: 33%;
  margin-bottom: 10px;
  font-size: 14px;
}
.img {
  height: 120px;
  margin-right: 40px;
  position: relative;
}
.name {
  position: absolute;
}
.tab {
  /* border: 1px solid #666363; */
  box-shadow: 0px 2px 7px 2px #ebeef5;
}
.tab >>> .el-tabs__nav-scroll {
  padding: 0 30px;
  box-sizing: border-box;
}
.tab >>> .el-tabs__item {
  color: #000 !important;
  font-family: PingFangSC-Medium, PingFang SC;
}
.el-table >>> .warningRed {
  color: #d81212;
}
.el-table >>> .warningBlack {
  color: #000;
}
.el-table >>> .warningGreen {
  color: #2a7533;
}
.el-table >>> .warningYellow {
  color: #beb842;
}
.el-table >>> .redBank {
  background: #d81212;
  color: #000;
}
/* .tab >>> .cell {
  color: #000;
} */
</style>

